import { useEffect, useRef, useState } from 'react'
import CartProducts from '../../Components/BasketPage/CartProducts';
import DeliveryAndPayment from '../../Components/BasketPage/DeliveryAndPayment';
import CartSummary from '../../Components/BasketPage/CartSummary';
import OrderCompleted from '../../Components/BasketPage/OrderCompleted';
import NavigationSection from '../../Components/BasketPage/NavigationSection';
import { useCart } from '../../Providers/CartProvider';
import Footer from '../../Components/Footer';
import LoadingSpinner from '../../Components/Components/LoadingSpinner';
import { toast } from 'react-toastify';
import { useOrder } from '../../Providers/OrderProvider';
import useGetRelatedProducts from '../Shop/Hooks/useGetRelatedProducts';
import useRegisterOrder from './hooks/useRegisterOrder';
import CustomSwiper from '../../Components/Components/CustomSwiper';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useCheckUserRole from '../../Components/BasketPage/Hooks/useCheckUserRole.ts';
import { UserRole } from '../../Data/UserRolesEnum.ts';
import InformationErrorModal from '../../Components/Components/Modals/InformationErrorModal.jsx';
import ErrorBoundary from '../../Components/ErrorBoundary/ErrorBoundary.jsx';
import { useOffers } from '../../Providers/OffersProvider.jsx';
import CartPageIndexSideBar from './Components/CartPageIndexSideBar.jsx';
import { useAuth } from '../../Providers/AuthProvider.jsx';
import LoginAndPrepareOffer from '../../Components/LoginAndPrepareOffer.jsx';
import { useCustomer } from '../../Providers/CustomerProvider.jsx';
import useCheckOtdAvailabilityByProducts from '../../Components/BasketPage/Hooks/useCheckOtdAvailabilityByProducts.jsx';
import { useParams } from '../../Providers/ParamsProvider.jsx';
import useGetLoadingSpinnerColor from '../../Hooks/useGetLoadingSpinnerColor.tsx';
import { ConvertPriceToString } from '../../Helpers/CustomConverter.jsx';
import ScrollUpArrow from '../../Components/Components/ScrollUpArrow.jsx';
import { CiCircleInfo } from "react-icons/ci";

import './CartPageStyles.css'

const CartPageIndex = () => {
    const navigate = useNavigate()
    const { isMobile } = useParams()
    const [searchParams] = useSearchParams() //pobieranie danych pod realizacje oferty
    const custId = searchParams.get('custId')
    const offerNo = searchParams.get('offerNo')
    const offerSiteId = searchParams.get('offerSiteId')
    const [offerModalObj, setOfferModalObj] = useState({ isVisible: false, message: '' })

    const { cartItems, getBasket } = useCart()
    const { orderInfo, setOrderInfo } = useOrder()
    const [currentStage, setCurrentState] = useState(1)
    const [orderCompleted, setOrderCompleted] = useState(false)
    const [order, setOrder] = useState([]);
    const [pending, setPending] = useState(false)
    const [lockProceed, setLockProceed] = useState(false)
    const { relatedProducts } = useGetRelatedProducts(null, cartItems.basketItems)
    const { handleRegisterOrder } = useRegisterOrder()
    const [cartItemsToSummary, setCartItemsToSummary] = useState(cartItems)
    const { isUserHasAccess } = useCheckUserRole()
    const [showNoAccessMessage, setShowNoAccessMessage] = useState(false)
    const { handleGetBasketForAcceptedOffer, orderItemsFromOffer, setOrderItemsFromOffer, handleGetAvailabilityForAkceptedOffer } = useOffers()
    const { authState } = useAuth()
    const { creditInfo, handleGetCreditInfo } = useCustomer()
    const [isBankTransfer, setIsBankTransfer] = useState(false)
    const [showUnavailableProductsMessageModal, setShowUnavailableProductsMessageModal] = useState(false)
    const unavailableProductsMessageModalRef = useRef()
    const { checkOtdAvailabilityByProducts } = useCheckOtdAvailabilityByProducts()
    const [noAllProductsIsAvailable, setNoAllProductsIsAvailable] = useState(false)
    const [warningMessageObj, setWarningMessageObj] = useState({ show: false, message: '' })
    const { getSpinnerColor } = useGetLoadingSpinnerColor()

    useEffect(() => {
        handleGetCreditInfo() //co wejście odświeżamy limit kredytowy
        handleGetOffer()

        return () => {
            setOrderItemsFromOffer([]) //czyszczenie realizowanej oferty po wyśjciu z koszyka
        }
    }, [])

    useEffect(() => {
        handleGetAvailabilityForAkceptedOffer() //Pobieramy ponownie dane jeżeli zmieni sie magazyn
    }, [authState.whId])

    useEffect(() => {
        const checkAvailability = async () => {
            const res = await checkOtdAvailabilityByProducts(orderInfo.expectedDeliveryTime)
            if (res && currentStage === 2) {
                handleSetWarningMessage(`Przynajmniej jeden produkt przekracza ilości dostępne na wybranym magazynie na dzień: ${orderInfo.expectedDeliveryTime}.`)
            }
            setNoAllProductsIsAvailable(res)
        }
        checkAvailability()
    }, [orderInfo.expectedDeliveryTime, cartItems.basketItems, orderItemsFromOffer])

    useEffect(() => {
        if (cartItems.basketItems && cartItems.basketItems.filter(x => x.isSelected).length > 0) {
            setCartItemsToSummary(cartItems)
        }
        if ((cartItems && cartItems.unavailableProductsIndexes && cartItems.unavailableProductsIndexes.length > 0) && !unavailableProductsMessageModalRef.current) {
            unavailableProductsMessageModalRef.current = true
            setShowUnavailableProductsMessageModal(true)
        }
    }, [cartItems])

    useEffect(() => { //odznaczenie limitu, jeżeli przekroczymy jego wartość             
        if (creditInfo && cartItemsToSummary && orderInfo.payment === 'Limit kredytowy' && (creditInfo.remainCredit < cartItemsToSummary.totalCostGross)) {
            handleSetWarningMessage('Przekroczyłeś swój limit kredytowy wartością zamówienia, rodziaj płatności został zmieniony')
            setOrderInfo(prev => ({
                ...prev,
                payment: ''
            }))
        }
    }, [cartItemsToSummary])

    const handleGetOffer = async () => {
        if (custId && offerNo) {
            setPending(true)
            const result = await handleGetBasketForAcceptedOffer(custId, offerNo, offerSiteId)
            setPending(false)
            if (result.errorMessage) {
                setOfferModalObj({ isVisible: true, message: result.errorMessage })
            }
            else {
                setOrderItemsFromOffer(result.basketItems)
            }
        }
    }
    const nextStage = async () => {
        if (!custId) {
            if (!cartItems || cartItems.basketItems.filter(x => x.isSelected).length === 0) {
                return
            }
        }

        if (currentStage === 2 && (!orderInfo.authorizedPersons || !orderInfo.deliveryType || !orderInfo.deliveryAddress || !orderInfo.payment || !orderInfo.expectedDeliveryTime)) {
            handleSetWarningMessage('Aby kontynuować, proszę uzupełnić wszystkie dane w dostawie i płatności')
            return
        }
        if (currentStage === 3) {
            if (!isUserHasAccess(UserRole.Orders)) {
                setShowNoAccessMessage(true)
                return
            }
            setPending(true)
            let tmpOfferNo = offerNo ? offerNo : null
            let tmpOfferSiteId = offerSiteId ? offerSiteId : null
            setIsBankTransfer(orderInfo.payment === 'Przelew tradycyjny' ? true : false)
            let result = await handleRegisterOrder(tmpOfferNo, tmpOfferSiteId)
            if (result === 'Brak limitu') {
                toast.warning(<>
                    Przekroczyłeś swój limit kredytowy wartością zamówienia,
                    <br />
                    aby kontynuować wybiesz inny rodziaj płatności!
                    <br />
                    Rodziaj płatności został zmieniony
                </>)
                setOrderInfo(prev => ({
                    ...prev,
                    payment: ''
                }))
                setCurrentState(2)
            }
            else if (result === 'Brak cennika') {
                toast.error(<>
                    Kontrahent nie ma wygenerowanego cennika!
                    <br />
                    Nie możesz zrealizować zamówienia,
                    <br />
                    spróbuj ponownie za chwilę.
                </>)
            }
            else if (result) {
                setOrder(result)
                navigate('/Cart')
                setOrderCompleted(true)
            }
            else {
                setOrderCompleted(false)
                toast.error('Błąd w trakcie składania zamówienia. Spróbuj ponownie za chwilę.')
            }
            setPending(false)
            return
        }
        setCurrentState(prev => prev + 1)
    }
    const prevStage = () => {
        setCurrentState(prev => prev - 1)
    }

    const getCurrentStage = (stage) => {
        switch (stage) {
            case 1:
                return <CartProducts
                    setLockProceed={setLockProceed}
                />
            case 2:
                return <DeliveryAndPayment
                    handleSetWarningMessage={handleSetWarningMessage}
                />

            case 3:
                return <CartSummary />
            default:
                break
        }
    }
    const handleSetCurrentStage = (stage) => {
        if (custId) {//tryb oferty            
            if (lockProceed) {
                return
            }
            if (stage === 3 && (
                orderInfo.authorizedPersons === null || orderInfo.deliveryType === null || orderInfo.deliveryAddress === null ||
                orderInfo.payment === null)) {
                handleSetWarningMessage('Aby kontynuować, proszę uzupełnić wszystkie dane w dostawie i płatności')
                return
            }
            setCurrentState(stage)
        }
        else {
            if (lockProceed || !cartItems.basketItems || cartItems.basketItems.filter(x => x.isSelected).length === 0) {
                return
            }
            if (stage === 3 && (
                orderInfo.authorizedPersons === null || orderInfo.deliveryType === null || orderInfo.deliveryAddress === null ||
                orderInfo.payment === null)
            ) {
                handleSetWarningMessage('Aby kontynuować, proszę uzupełnić wszystkie dane w dostawie i płatności')
                return
            }
            if (cartItems && cartItems.basketItems.filter(x => x.isSelected).length > 0) {
                setCurrentState(stage)
            }
        }
    }

    const handleSetWarningMessage = (message) => {
        setWarningMessageObj(prev => {
            const alreadyIncluded = prev.message.includes(message)
            return {
                show: true,
                message: alreadyIncluded ? prev.message : (prev.message ? prev.message + '\n' + message : message + '\n')
            }
        })
    }

    const getLoadingDisabledButton = (isMobile = false) => {
        let spinnerColor = getSpinnerColor()
        if (isMobile) {
            return (
                <button className='btn-app-disabled' style={{ width: '100%', borderRadius: '0' }}>
                    <div className={`spinner-border ${spinnerColor}`} />
                </button>
            )
        }
        return (
            <button className='btn-app-disabled mb-3'>
                <div className={`spinner-border ${spinnerColor}`} />
            </button>
        )
    }

    const generateNoAvailableProductsByOTDLabel = () => {
        if (noAllProductsIsAvailable) {
            return (<div className="col no-available-products mb-3">
                <CiCircleInfo size={25} />
                <span className={`${isMobile && 'mobile-font'} ms-3`}>Przynajmniej jeden produkt przekracza ilości dostępne na wybranym magazynie...</span>
            </div>)
        }
    }

    const offerModeTextStyle = orderItemsFromOffer && orderItemsFromOffer.length > 0 ? '' : 'collapse'

    if (pending) {
        return <LoadingSpinner />
    }
    if (custId && (!authState.user || authState.custId != custId)) {
        return <LoginAndPrepareOffer
            custId={custId}
            offerNo={offerNo}
            offerSiteId={offerSiteId}
        />
    }
    if (orderCompleted) {
        return (
            <>
                <OrderCompleted
                    order={order}
                    basket={cartItemsToSummary}
                    isBankTransfer={isBankTransfer}
                />
                {orderItemsFromOffer.length > 0 && getBasket()}
                <Footer />
            </>
        )
    }
    else {
        return (
            <>
                <ErrorBoundary>
                    <ScrollUpArrow />
                    <InformationErrorModal
                        show={warningMessageObj.show}
                        setShow={() => setWarningMessageObj({ show: false, message: '' })}
                        title={'Ważna informacja'}
                        message={warningMessageObj.message}
                        isVersionControlInfo={false}
                        showCloseButton={true}
                    />
                    <InformationErrorModal
                        show={showUnavailableProductsMessageModal}
                        setShow={() => { setShowUnavailableProductsMessageModal(false) }}
                        title={'UWAGA!'}
                        message={<>
                            <span>Nie udało się wczytać niektórych pozyci z powodu ich wycofania lub braku dostępności!</span>
                            <br />
                            <span style={{ color: 'black' }}>Oto lista pominiętych indeksów:</span>
                            <br />
                            {cartItems && cartItems.unavailableProductsIndexes && cartItems.unavailableProductsIndexes.map((idx) => (
                                <span key={idx} style={{ color: 'black' }}>
                                    • {idx}
                                    <br />
                                </span>
                            ))}
                        </>}
                        isError={true}
                    />
                    <InformationErrorModal
                        show={offerModalObj.isVisible}
                        setShow={() => navigate('/')}
                        title={'Błąd'}
                        message={offerModalObj.message}
                        isError={true}
                    />
                    <InformationErrorModal
                        show={showNoAccessMessage}
                        setShow={() => setShowNoAccessMessage(false)}
                        title={'Brak uprawnień!'}
                        message={<>
                            <span>Brak uprawnień do składania zamówień!</span>
                            <br />
                            <span>Skontaktuj się z administratorem strony</span>
                        </>}
                        isError={true}
                    />
                    <div className='container-fluid-with-paddings'>
                        <div className="row">
                            <div className="col-12 col-xxl-9">
                                <div className="row d-flex justify-content-center">
                                    <NavigationSection
                                        currentStage={currentStage}
                                        setCurrentState={handleSetCurrentStage}
                                    />
                                </div>
                                <div className={`row ms-2 me-2 ${offerModeTextStyle}`}>
                                    <div className={`col no-available-products mb-3`}>
                                        <CiCircleInfo size={25} />
                                        <span className={`${isMobile && 'mobile-font'} ms-3`}>Tryb realizowania oferty, jeżeli wyjdziesz z tego okna stracisz wczytane dane z oferty!</span>
                                    </div>
                                </div>
                                <div className="row ms-2 me-2">
                                    {generateNoAvailableProductsByOTDLabel()}
                                </div>
                                {getCurrentStage(currentStage)}
                                <div className="row">
                                    {currentStage === 1 && cartItems && cartItems.basketItems && cartItems.basketItems.length > 0 ?
                                        (
                                            <div>
                                                <CustomSwiper
                                                    products={relatedProducts}
                                                    header={"Zamów również:"}
                                                    loop={false}
                                                    refreshPage={false}
                                                />
                                            </div>
                                        ) : (null)}
                                </div>
                            </div>
                            <div className="col-12 mt-3 col-xxl-mt-0 col-xxl-3">
                                <CartPageIndexSideBar
                                    currentStage={currentStage}
                                    nextStage={nextStage}
                                    prevStage={prevStage}
                                    lockProceed={lockProceed}
                                    getLoadingDisabledButton={getLoadingDisabledButton}
                                />
                            </div>
                        </div>
                        <MobileNawigationBottomBar
                            stage={currentStage}
                            nextStage={nextStage}
                            lockProceed={lockProceed}
                            getLoadingDisabledButton={getLoadingDisabledButton}
                            orderItemsFromOffer={orderItemsFromOffer}
                            isMobile={isMobile}
                        />
                    </div>
                    <Footer />
                </ErrorBoundary>
            </>
        )
    }
}

const MobileNawigationBottomBar = ({ stage, nextStage, lockProceed, getLoadingDisabledButton, orderItemsFromOffer, isMobile }) => {
    const { cartTotalGross, getBasketTotalValue } = useCart()

    const getButtonText = (stage) => {
        switch (stage) {
            case 1:
                return 'Zamów teraz'
            case 2:
                return 'Przejdź do podsumowania'
            case 3:
                return 'Zamawiam i płacę'
            default:
                return ''
        }
    }

    const getSumGross = () => {
        if (orderItemsFromOffer.length > 0) {
            return ConvertPriceToString(getBasketTotalValue(orderItemsFromOffer).totalGross)
        }
        else {
            return ConvertPriceToString(cartTotalGross)
        }
    }

    if (!isMobile || getSumGross() === '0,00 zł') {
        return null
    }
    return (<div className='container-fluid cart-mobile-nav-bar fixed-bottom pt-1' style={{ fontSize: '16px' }}>
        <div className="row ms-2 me-2 mb-2">
            <div className="col-6 text-start">
                <span>Suma brutto</span>
            </div>
            <div className="col-6 text-end">
                <span>{getSumGross()}</span>
            </div>
        </div>
        <div className="row">
            <div className="col-12">
                {lockProceed ? (getLoadingDisabledButton(true)) :
                    (<button className='btn-app-primary' style={{ width: '100%', borderRadius: '0' }} onClick={() => nextStage()}>{getButtonText(stage)}</button>)}
            </div>
        </div>
    </div>)
}

export default CartPageIndex